export class ErrorResponseWrapperModel {
    responce_status: number;
    data: any;
    message: any;
    _body: any;
}
